import React from 'react';
import { useTranslation } from 'react-i18next';

import ConfirmationModal from 'components/Modals/presets/ConfirmationModal';

export function UnarchiveConflictModal({ message, ...props }) {
  const { t } = useTranslation();
  return (
    <ConfirmationModal
      buttonText={t('Unarchive')}
      heading={t('Create New or Unarchive?')}
      defaultLeftBtnText={t('Cancel')}
      additionalButtonText={t('Create New')}
      {...props}
    >
      {message}
    </ConfirmationModal>
  );
}

export function UnarchiveForbiddenModal({ message, ...props }) {
  const { t } = useTranslation();
  return (
    <ConfirmationModal
      actionBtnColor="blue"
      buttonText={t('Close')}
      leftBtn={false}
      heading={t('This is an Archived Record')}
      {...props}
    >
      {message}
    </ConfirmationModal>
  );
}

export function UpdateConflictModal({ message, ...props }) {
  const { t } = useTranslation();
  return (
    <ConfirmationModal
      buttonText={t('Save and Discard')}
      heading={t('This is an Archived Record')}
      defaultLeftBtnText={t('Cancel')}
      {...props}
    >
      {message}
    </ConfirmationModal>
  );
}
